import COMMON_TYPES from '../../../actions/types';
import * as analytics from '../../../analytics';

import { details } from '../../../api/common';

const searchDetails = params =>
  details({ id: params.id, path: 'legislative.processe.php' })
    .then(response => {
      return {
        type: COMMON_TYPES.detailsGetResult,
        payload: response,
      }
    })
    .catch(() => ({ type: COMMON_TYPES.detailsGetResultError }))

export const toggleDetailsLayer = params => {
  if(params && params.id) {
    analytics.registerEvent({
      category: analytics.categories.legislative,
      action: analytics.actions.legislativeDetails,
    });

    return [
      { type: COMMON_TYPES.toggleLayer, payload: 'details' },
      searchDetails(params),
    ]
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.detailsGetResult, payload: { data: null } }
  ];
};
